$(document).ready(function () {
  if ($(window).width() < 1025) {
    $(".com_title").next(".com_content").hide();
  }
  $(".com_title").click(function () {
    $(this).next(".com_content").slideToggle();
    $(this).toggleClass("footer-block__heading_active");
  });

  $(".tab-block-heading").click(function () {
    if ($(this).hasClass("active-tab")) {
      $(this).siblings(".tab-block-content").slideUp();
      $(this).removeClass("active-tab");
    } else {
      $(this).parents(".tab__block").find(".tab-block-content").slideUp();
      $(this)
        .parents(".tab__block")
        .find(".tab-block-heading")
        .removeClass("active-tab");
      $(this).siblings(".tab-block-content").slideToggle();
      $(this).toggleClass("active-tab");
    }
  });

  //  -------------- cart quick add Model

  function open_quick_view() {
    $("#quick-buy-model").fadeIn(200);
    setTimeout(() => {
      $("#quick-buy-model .quick-buy-content-block").slideDown(200);
    }, 200);
    setTimeout(() => {
      $("#quick-buy-model").addClass("anime");
    }, 600);
  }
  function close_quick_view() {
    $("#quick-buy-model").removeClass("anime");
    setTimeout(() => {
      $("#quick-buy-model .quick-buy-content-block").slideUp(200);
    }, 200);
    setTimeout(() => {
      $("#quick-buy-model").fadeOut(200);
    }, 600);
    setTimeout(() => {
      $("#quick-buy-model").remove();
    }, 800);
  }

  $(document).on("click", ".product-quick-view-btn", function (e) {
    e.preventDefault();
    var url = $(this).data("product-url");
    fetch(url + "?section_id=quick-add")
      .then((responseText) => responseText.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        var a = $(html).find("#shopify-section-quick-add").html();
        $("body").append(a);
        Shopify.PaymentButton?.init();
      })
      .finally(() => {
        open_quick_view();
      });
  });

  $(document).on(
    "click",
    ".quick-buy-close,#quick-buy-model .overlay",
    function (e) {
      e.preventDefault();
      close_quick_view();
    }
  );

  $(document).on("click", ".view_cart", function (e) {
    e.preventDefault();
    close_quick_view();
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.dispatchEvent(new Event("click"));
  });

  $(document).on(
    "change",
    ".quick-buy-content-block .quick-buy-variant input[type=radio]",
    function () {
      var val = $(this).val();
      $(this).siblings(".form__label").find("span").text(val);
    }
  );

  //  -------------- cart quick add Model

  // --------------- product page varint slider

  // var swiper = new Swiper(".grind_grid", {
  //   slidesPerView: 2,
  //   spaceBetween: 8,
  //   pagination: {
  //     el: ".swiper-pagination",
  //     clickable: true,
  //   },
  //   breakpoints: {
  //     393: {
  //       slidesPerView: 3,
  //       spaceBetween: 8,
  //     },
  //     1200: {
  //       slidesPerView: 4,
  //       spaceBetween: 8,
  //     },
  //     1600: {
  //       slidesPerView: 5,
  //       spaceBetween: 8,
  //     },
  //   },
  // });

  // --------------- product page varint slider

  // --------------  product page add to cart price js

  function price_to_button() {
    if ($(".price-per-item__container .quantity__input").length) {
      var currency = $(".product .product-form__submit .btn_price_wrap").data(
        "currency"
      );
      // console.log('currency' , currency);
      var price =
        parseFloat(
          $(".product .product-form__submit .btn_price_wrap span").data(
            "variant-price"
          )
        ) * parseFloat($(".price-per-item__container .quantity__input").val());
      price = price / 100;
      console.log("currency", price);
      var main_price = currency + price.toFixed(2);
      $(".product .product-form__submit .btn_price_wrap span").text(
        " - " + main_price
      );
    }
  }
  $(".price-per-item__container .quantity__input").change(function () {
    price_to_button();
  });

  // --------------  product page add to cart price js

  //   var subscribe_interval = setInterval(function () {
  //   if ($(".rc-container-wrapper").length) {
  //     clearInterval(subscribe_interval);
  //     $(".rc-container-wrapper .rc-widget .rc-radio.rc-option__subsave").append(cust_subscription_html);
  //     $(".rc-widget .rc-radio__label .rc-option__discount").append(" OFF");
  //     $(".rc-widget .rc-radio .rc-radio__input:checked").trigger("change");
  //   }
  //   if ($(".appstle_sub_widget").length) {
  //     clearInterval(subscribe_interval);
  //     $(".appstle_subscription_wrapper_option.appstle_include_dropdown .appstle_subscribe_option").append(cust_subscription_html);
  //     // $("#subscription_custm_data").show();
  //   }
  // }, 100);

  // function sticky_price_change() {
  //   $(
  //     ".sticky_cart_wrap .sticky_cart_row .sticky_button_wrapp .product-form__submit .btn_price_wrap"
  //   ).html(
  //     $(
  //       ".product .product__info-wrapper .product-form__buttons .product-form__submit .btn_price_wrap"
  //     ).html()
  //   );
  //   $(".sticky_cart_wrap .sticky_cart_row .sticky_main_price").html(
  //     $(".product .product__info-wrapper .product_main_price").html()
  //   );
  // }

  // $(document).on(
  //   "change",
  //   ".rc-widget .rc-radio .rc-radio__input",
  //   function () {
  //     if ($(this).val() == "subsave") {
  //       $(".product .product__info-wrapper .product-form__buttons").addClass(
  //         "subscribe_btn_wrap"
  //       );
  //       $(".sticky_cart_wrap .sticky_cart_row .sticky_button_wrapp").addClass(
  //         "subscribe_btn_wrap"
  //       );
  //       $(
  //         '.product .product__info-wrapper variant-radios .product-form__input[data-opt_handle="quantity"]'
  //       ).hide();
  //       $(
  //         '.product .product__info-wrapper variant-radios .product-form__input[data-opt_handle="quantity"]'
  //       )
  //         .find("label")
  //         .eq(0)
  //         .trigger("click");
  //       $(
  //         ".product .product__info-wrapper .subscribe_variant_text_wrap"
  //       ).hide();
  //       $(".product .product__info-wrapper .product_form_after_pay").hide();
  //     } else {
  //       $(".product .product__info-wrapper .product-form__buttons").removeClass(
  //         "subscribe_btn_wrap"
  //       );
  //       $(
  //         ".sticky_cart_wrap .sticky_cart_row .sticky_button_wrapp"
  //       ).removeClass("subscribe_btn_wrap");
  //       $(
  //         '.product .product__info-wrapper variant-radios .product-form__input[data-opt_handle="quantity"]'
  //       ).show();
  //       $(
  //         ".product .product__info-wrapper .subscribe_variant_text_wrap"
  //       ).show();
  //       $(".product .product__info-wrapper .product_form_after_pay").show();
  //     }
  //     setTimeout(sticky_price_change, 1200);
  //   }
  // );

  // $(document).on(
  //   "change",
  //   ".product .product__info-container .product-form__input input[type=radio]",
  //   function () {
  //     if ($(".rc-container-wrapper").length) {
  //       setTimeout(sticky_price_change, 1200);
  //     }
  //   }
  // );

  if($('.icon_pause_video').length > 0) {
   
    
    $('.video_with_btn video').click(function(){
      $(this).get(0).pause();
      $(this).parent().find('.icon_pause_video').css('display', 'flex');
    });
  }
  setInterval(function(){
    document.querySelectorAll('.facets__list .list-menu__item label .facet-checkbox__text').forEach(element => {
      element.textContent = element.textContent.replace(/\(\d*\)/g, '');
    });
  }, 10)

  document.querySelectorAll("header-menu details").forEach(function(detail) {
    detail.addEventListener("mouseenter", function() {
      detail.setAttribute("open", "open");
    });
  
    detail.addEventListener("mouseleave", function() {
      detail.removeAttribute("open");
    });
  });

  $(document).ready(function () {
  // Open popup
  $('.instalment-payment .instalment-payment-block, .afterpay-payment, .zip-payment').click(function () {
    var popup = $(this).data('title'); // Use $(this) instead of 'this'
    $('.instalment-payment .' + popup).addClass('active');
    $('body').css("overflow", "hidden");
    $('.shopify-section-group-header-group').css("z-index", "0");
  });

  // Close popup
  $('.instalment-payment-popup .close, .instalment-payment-popup .instalment-payment-popup-overlay').click(function () {
    $(this).parents('.instalment-payment-popup').removeClass('active');
    $('body').css("overflow", "auto");
    $('.shopify-section-group-header-group').css("z-index", "4");
  });
});

  
  
  
});
 document.addEventListener("DOMContentLoaded", function () {
    if (window.innerWidth < 768) {
      new Swiper('.mobile-announcement-slider', {
        slidesPerView: 1,
        loop: true,
        autoplay: {
          delay: 2000,
        },
        pagination:false,
        
      });
    }
  });

// function getSelectedSubscriptionPrice() {
//   const selectedRadio = document.querySelector('input[name="selling_plan"]:checked');

//   let finalPrice = null;
//   let compareAtPrice = null;

//   if (selectedRadio) {
//     let wrapper = selectedRadio.closest(".appstle_subscription_radio_wrapper") ||
//                   selectedRadio.closest(".appstle_subscription_wrapper_option");

//     if (wrapper) {
//       const priceElement = wrapper.querySelector(".appstle_subscription_amount.transcy-money");
//       const compareAtElement =
//         wrapper.querySelector(".appstle_subscription_amount_compare_at_price") ||
//         wrapper.querySelector(".appstle_subscription_compare_amount");

//       finalPrice = priceElement?.textContent.trim();
//       compareAtPrice = compareAtElement?.textContent.trim();
//     }
//   }

//   // 🔄 If no subscription pricing found, fallback to Shopify's regular price
//   if (!finalPrice) {
//     const shopifyFinal = document.querySelector(".price .price-item--regular");
//     const shopifyCompare = document.querySelector(".price .price-item--compare");

//     finalPrice = shopifyFinal?.textContent.trim();
//     compareAtPrice = shopifyCompare?.textContent.trim();
//   }

//   if (!finalPrice) return; // still nothing found, exit

//   // 💳 Update Installment Text
//   const installmentWrapper = document.querySelectorAll(".instalment-payment-text .price");
//   if (installmentWrapper.length) {
//     const finalPriceNum = parseFloat(finalPrice.replace(/[^0-9.-]+/g, ""));
//     if (!isNaN(finalPriceNum)) {
//       const installment = (finalPriceNum / 4).toFixed(2);
//       installmentWrapper.forEach((el) => {
//         el.textContent = `Or pay 4x $${installment} with`;
//       });
//     }
//   }

//   // 💰 Update Sticky Price Block
//   const priceWrapper = document.querySelector(".custom_regularprice");
//   if (!priceWrapper) return;

//   priceWrapper.innerHTML = ''; // clear first

//   const finalPriceSpan = document.createElement("span");
//   finalPriceSpan.className = "price-item price-item--regular comman_class customprice33 appstle_subscription_final_price";
//   finalPriceSpan.textContent = finalPrice;
//   priceWrapper.appendChild(finalPriceSpan);

//   const variantPriceEl = document.querySelector(".price.variant-price");
//   if (variantPriceEl) {
//     let priceText = finalPrice;

//     if (compareAtPrice) {
//       priceText = `${finalPrice} <span style="text-decoration:line-through; margin-left: 5px;">${compareAtPrice}</span>`;
//     }

//     variantPriceEl.innerHTML = priceText;
//   }

//   // Add Compare Price and SAVE % if available
//   if (compareAtPrice) {
//     const mainPriceWrapper = document.querySelector(".price__regular.mainprice__regular");
//     if (mainPriceWrapper) mainPriceWrapper.style.display = "none";
//     priceWrapper.style.display = "block";

//     const comparePriceSpan = document.createElement("span");
//     comparePriceSpan.className = "price-item price-item--regular comman_class customprice33";
//     comparePriceSpan.style.textDecoration = "line-through";
//     comparePriceSpan.style.marginLeft = "5px";
//     comparePriceSpan.textContent = compareAtPrice;
//     priceWrapper.appendChild(comparePriceSpan);

//     const saveSpan = document.createElement("span");
//     saveSpan.className = "appstle_subscription_element appstle_subscription_save";
//     const priceVal = parseFloat(finalPrice.replace(/[^0-9.-]+/g, ""));
//     const compareVal = parseFloat(compareAtPrice.replace(/[^0-9.-]+/g, ""));
//     const discount = Math.round(((compareVal - priceVal) / compareVal) * 100);
//     saveSpan.textContent = `SAVE ${discount}%`;
//     saveSpan.style.marginLeft = "5px";
//     priceWrapper.appendChild(saveSpan);
//   }
// }

// // 🔁 Watch for subscription selection changes
// document.addEventListener("change", function (event) {
//   if (event.target.matches('input[name="selling_plan"]') || event.target.matches('#appstle_selling_plan0')) {
//     setTimeout(() => {
//       getSelectedSubscriptionPrice();
//     }, 900);
//   }
// });

// // 🔄 Watch for Appstle subscriptions loaded OR fallback to regular price
// function waitForAppstleSubscription() {
//   const checkInterval = setInterval(() => {
//     const hasSubscriptionUI = document.querySelector('#appstle_selling_plan_label_20') || document.querySelector('#appstle_selling_plan_label_10');
//     const isLoaded = document.querySelector(".price .price-item--regular");

//     if (hasSubscriptionUI || isLoaded) {
//       clearInterval(checkInterval);
//       getSelectedSubscriptionPrice();
//     }
//   }, 700);
// }

// document.addEventListener("DOMContentLoaded", waitForAppstleSubscription);

// // 🔁 Watch for variant changes
// document.addEventListener("DOMContentLoaded", () => {
//   const variantInput = document.querySelector('input[name="id"]');
//   if (variantInput) {
//     let lastVariant = variantInput.value;

//     const observer = new MutationObserver(() => {
//       const newVariant = variantInput.value;
//       if (newVariant !== lastVariant) {
//         lastVariant = newVariant;
//         setTimeout(() => {
//           getSelectedSubscriptionPrice();
//         }, 2000);
//       }
//     });

//     observer.observe(variantInput, {
//       attributes: true,
//       attributeFilter: ["value"],
//     });
//   }
// });



// Video Sound Off Common Btn JS 

  $(document).ready(function () {
  $('.video_sound_block').on('click', function() {
    $(this).toggleClass("active");
    const videoElement = $(this).parent('.sound_common_block').find('video').get(0);
    videoElement.muted = !videoElement.muted;
    $(this).find('.sound_on_video').toggle();
    $(this).find('.sound_off_video').toggle();
  });

  // setInterval(function () {
  //   if($("body.temp__product").length != 0){
  //     $(".appstle_subscription_final_price").parents(".custom_regularprice").siblings(".price__regular.mainprice__regular").hide();
  //   }
  // }, 5);

 });

// Video Sound Off Common Btn JS 


